import ArrowDownward from '@mui/icons-material/ArrowDownward'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useGetMentions } from '../../hooks/useGetMentions'

export const MOBILE_MENTIONS_SECTION_ID = 'mobile-mentions-section'

export const ScrollToMentionsBanner = () => {
  const { t } = useTranslation('dashboard')
  const { data: unresolvedMentionsData } = useGetMentions({ isResolved: false })
  const unresolvedMentionsCount = unresolvedMentionsData?.mentions?.length ?? 0

  const handleClick = () => {
    document.getElementById(MOBILE_MENTIONS_SECTION_ID)?.scrollIntoView({ behavior: 'smooth' })
  }

  if (unresolvedMentionsCount === 0) return null

  return (
    <Button
      onClick={handleClick}
      fullWidth
      sx={{
        px: 4,
        py: 3,
        backgroundColor: 'neutralLight.50',
        border: 1,
        borderColor: 'neutralLight.300',
        borderRadius: 2,
        textTransform: 'none',
        gap: 2,
        '&:hover': {
          bgcolor: 'neutralLight.100',
        },
        mb: 3,
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          flexShrink: 0,
        }}
      />
      <Typography variant="HeaderSubtitleMediumMedium">
        {t('mentions.unresolved-mentions', { count: unresolvedMentionsCount })}
      </Typography>

      <Box sx={{ flexGrow: 1 }} />

      <ArrowDownward sx={{ color: 'neutralLight.700' }} />
    </Button>
  )
}
